export const DEFAULT_LANGUAGE = 'en-GB'; // eslint-disable-line import/prefer-default-export
